import Axios from "axios";

const state = () => ({
  staff: {},
  all_staff: {},
  info: {},
  code: null,
  message: null,
  status: null,
  loading: false,
  host: process.env.VUE_APP_API_HOST || 'http://localhost:8020',
});

const mutations = {
  set_staff(state, staff){
    state.staff = staff
  },
  set_all_staff(state, all_staff){
    state.all_staff = all_staff
  },
  set_info(state, info){
    state.info = info
  },
  set_code(state, code){
    state.code = code
  },
  set_message(state, message){
    state.message = message
  },
  set_status(state, status){
    state.status = status
  },
  set_loading(state, loading){
    state.loading = loading
  }
};

const actions = {
  get_staff({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("set_loading", true);

      let url = state.host+"/sdm/employee/unit";
      let headers = { Authorization: "Bearer " + localStorage.getItem("token") };
      
      Axios.get(url, { headers: headers })
        .then((response) => {
          const staff = response.data;

          commit("set_loading", false);
          commit("set_staff", staff.sort((a, b) => a.nip - b.nip));
          resolve(response);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            localStorage.removeItem("token");
            delete Axios.defaults.headers.common["Authorization"];
            this.$router.push({ name: "home" });
          }
          commit('set_message', error.response.data.error_description)
          commit("set_loading", false);
          reject(error);
        });
    });
  },
  get_all_staff({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("set_loading", true);

      // https://api-intranet.lan.go.id/sdm/employee/ambilsemua

      let url = state.host+"/sdm/employee/ambilsemua";
      let headers = { Authorization: "Bearer " + localStorage.getItem("token") };
      
      Axios.get(url, { headers: headers })
        .then((response) => {
          const all_staff = response.data;

          commit("set_loading", false);
          commit("set_all_staff", all_staff.sort((a, b) => a.nip - b.nip));
          resolve(response);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            localStorage.removeItem("token");
            delete Axios.defaults.headers.common["Authorization"];
            this.$router.push({ name: "home" });
          }
          commit('set_message', error.response.data.error_description)
          commit("set_loading", false);
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};